
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import countries from "@/data/locations/countries";
import States from "@/entities/locationEntities/States";
import Provinces from "@/entities/locationEntities/Provinces";
import DropdownOption from "@/entities/DropdownOption";
import isAllStatesOfPrimaryCountry from "@/helpers/locations/stateOfPrimaryCountry";
import getCountryRelatedValue from "@/helpers/locations/getCountryRelatedValue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";

interface User_Location{
city: string,
country: string,
postalCode: string,
state: string,
}

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    CrossIconHover,
    ProfileCountrySelect,
    FormWrapper,
    RegionInput,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
    LoadingOverlay,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: Object || String, required: false })
  readonly location?: User_Location;

  isHovered: boolean = false;
  updatedLocation: object | string = this.location;
  city: string = this.location ? this.location.city : "";
  postalCode:  string = this.location ? this.location.postalCode : "";
  country: DropdownOption[] = [];
    countryFromDB: string = this.location.country
    ? this.location.country
    : "";
  state: DropdownOption[] = []; 
  allNullValue: boolean = false;

mounted(){
  const { city, state, country, postalCode } = this.location;
     this.allNullValue = !city && !state && !country && !postalCode;
}
 created(){
    
    if (this.location.country) {
      this.country = countries.filter(({ name }) => {
        const countryName = name.toLowerCase();
        const searchValue = this.location.country.toLowerCase();
        return countryName.includes(searchValue);
       
      });
    }

    if (this.primaryCountry) {
      this.state = getCountryRelatedValue<DropdownOption[]>({
        countries: this.country,
        primary: [],
        onlyUSA: this.filterMatchingOptions(
          this.states,
          this.location.state
        ),
        onlyCanada: this.filterMatchingOptions(
          this.provinces,
          this.location.state
        ),
        defaultValue: [],
      });
    } else {
      this.state.push({
        id: this.location.state,
        name: this.location.state,
      });
    }
  }

 @Watch("countryName", { immediate: false })
  clearCountry(newCountry: string): void {
    if (newCountry !== this.countryFromDB || !Boolean(newCountry)) {
      this.state = [];
      this.city = "";
      this.postalCode = "";
    }
  }

  get countryName(): string {
    return this.country[0]?.name || "";
  }
  states: DropdownOption[] = (
    Object.keys(States) as Array<keyof typeof States>
  ).map((key) => {
    return {
      id: States[key],
      name: States[key],
    };
  });

  provinces: DropdownOption[] = (
    Object.keys(Provinces) as Array<keyof typeof Provinces>
  ).map((key) => {
    return {
      id: Provinces[key],
      name: Provinces[key],
    };
  });

  get primaryCountry(): boolean {
    const countryNames = this.country.map((country) => country.name);
    return isAllStatesOfPrimaryCountry(countryNames);
  }

  filterMatchingOptions(options: DropdownOption[], searchString: string) {
    return options.filter((option) =>
      this.hasSearchValue(option.name, searchString)
    );
  }

  hasSearchValue(optionName: string, searchString: string) {
    return optionName.toLowerCase().includes(searchString.toLowerCase());
  }

  closeModal(): void {
    this.$emit("close");
  }

  addLocation() {
     if(this.allNullValue){
      const getAllValue = {
        city: this.city,
        state: this.state,
        country: this.country,
        postalCode: this.postalCode,
      }
      this.updatedLocation = getAllValue;
       this.$emit("add-location", getAllValue);
     }
     else{
       this.$emit("edit-location", {
       
        oldName: this.location,
        newName: this.updatedLocation,
       });
     }
    this.closeModal();
  }

  editLocation() {
   this.$emit("edit-location", {
        oldName: this.updatedLocation,
        newName: this.location,
       });
    this.closeModal();
  }

  
}
